import { Component, OnInit, ViewChild, ChangeDetectorRef, TemplateRef, ElementRef } from '@angular/core';
import { MatDialog, MatSlideToggleChange } from '@angular/material';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { AcceptModalComponent } from '../dashboardModals/accept-modal/accept-modal.component';
import { AssignModalComponent } from '../dashboardModals/assign-modal/assign-modal.component';
import { trigger, state, transition, style, animate } from '@angular/animations';

import { HttpService } from '../http.service';
import { StorageService } from '../storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, Subscription, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, mergeMap, map,startWith } from 'rxjs/operators';
import { TimeService } from '../time.service';
import { EventService } from '../event.service';

import * as moment from 'moment';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { SnackbarService } from '../snackbar.service';
import { SocketService } from '../socket.service';
import { MessagingService } from '../messaging.service';
import { DateTime } from 'luxon';
import { ValidationService } from '../validation.service';
import { ShipmentDetailsComponent } from '../dashboardModals/shipment-details/shipment-details.component';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { TranslateService } from '@ngx-translate/core';
import { Messages } from '../constants/messages';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { merge } from 'rxjs';

export interface Orders {
  _id: string;
  OIN: string;
  pickDate: string;
  from: Array<any>;
  dropDate: string;
  to: Array<any>;
  requested: string;
  freight: string,
  accepted: string;
  vehicle: object;
  // organization: object;
  shipper: object;
  costPerVehicle: string;
  // materials: Array<any>;
  // allocation: string;
  status: string;
  // totalShipments: number;


}

@Component({
  selector: 'app-order-dashboard',
  templateUrl: './order-dashboard.component.html',
  styleUrls: ['./order-dashboard.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0.6 }),
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ])
    ]),

  ],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class OrderDashboardComponent implements OnInit {

  video_URL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ACCEPT_ASSIGN_ORDER);

  currency = 'Rs';
  ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle','freight', 'requested', 'accepted', 'status'];
  ordersArray: any = [];
  totalOrders = 0;
  orders: any = [];
  showStatusTab = 0;
  tabIndex = 0;
  selectedOrderData: any;
  selectedOrderAllLocationsData: any;
  showOrderDetailsView = 0;
  shipmentsColumns = ['SIN', 'shipper'];
  showLoader = false;
  selectedStatus: any; // holds the selected status (Available/Deleted)
  statusArray = [
    {
      status: 'Active',
      is_deleted: false
    },
    {
      status: 'Deleted',
      is_deleted: true
    }
  ];

  shipmentStatusArray: any = [];
  assigned: any = [];
  inTransit: any = [];
  completed: any = [];
  tab = 0;
  filter = '';
  pageSize = 25;
  currencySymbol;
  selectedOrder: any;
  messages = new Messages();
  allocationColumns: string[] = ['slno', 'requested', 'accepted', 'cancelled', 'deadline', 'assigned', 'action'];
  allocationDataSource = [];
  @ViewChild('allocTable', { static: true }) allocTable: MatTable<any>;
  @ViewChild("uploadDocs", { static: true }) uploadDocs: TemplateRef<any>;
  @ViewChild("ChatBoxComponent", { static: true }) ChatBoxComponent: TemplateRef<any>;
  @ViewChild("outerbody", { static: false }) outerbody: ElementRef;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('paginatorTop',{static:false}) topPaginator: MatPaginator;
  @ViewChild('paginatorBottom',{static:false}) bottomPaginator: MatPaginator;
  totalCount  = 0;

  uploadDocsRef: any;
  carrierId: Subscription;

  // Filters
  filterOrder = '';
  filterShipper = '';
  dashboardFilters = {
    // oin: '',
    // shipper_name: '',
    is_deleted: false,
    limit: 0,
    skip: 0
  };
  urlParams = {
    mode: null,
    type: null,
    flash: null
  };
  textMessage = '';
  messageArray = [];
  carrierIdChatBox = '';
  documentId = '';
  chatboxRef: any;
  orderNumber = '';

  selectedOrderStatus: any;

  ordersList: MatTableDataSource<Orders>;
  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  searchTextChanged = new Subject<object>();
  subscription: Subscription;
  helpDataActive = [
    { head: 'Help', data: 'List of all recent Orders which shipper have posted.' },
    // { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  helpDataDeleted = [
    { head: 'Help', data: 'Track all Deleted/Cancelled Orders.' },
    // { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  constructor(private dialog: MatDialog, private translation: TranslateService, private changeDetection: ChangeDetectorRef, private http: HttpService,
    private storage: StorageService, private route: Router, private events: EventService,
    public timeService: TimeService, private snackbar: SnackbarService, private socket: SocketService,
    private fcmService: MessagingService, private actRoute: ActivatedRoute, private valid: ValidationService, private sanitizer: DomSanitizer) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');

    }
  }
  generateGetManyApiFitler(mode, type) {
    if (mode == 'live') {
      switch (type) {
        case 'acceptance':
          return 'd_acpt';
        case 'assignment':
          return 'd_asn';
      }
    } else {
      switch (type) {
        case 'orders':
          return 'p_ord';
        case 'acceptance':
          return 'p_acpt';
        case 'assignment':
          return 'p_asn';
      }
    }
  }

  ngOnInit() {
    // this.video_URL=environment.VIDEO_URL+'c5f4edd9-91a9-4faf-be5c-1f45132ea54e/embed',
    this.selectedStatus = this.statusArray[0];
    this.selectedOrderStatus = 'active';
    this.actRoute.paramMap.subscribe(params => {
      this.urlParams.mode = params.get('mode');
      this.urlParams.type = params.get('type');
      this.urlParams.flash = params.get('flash');

      if (this.urlParams.flash === 'flash') {
        this.changeOrder('flash');
      }
      if (this.urlParams.mode && this.urlParams.type) {
        this.filter = this.generateGetManyApiFitler(this.urlParams.mode, this.urlParams.type);
        this.getOrders();
      } else {
        this.getOrders({});
        const currency = JSON.parse(localStorage.getItem('carriers'));
        this.currencySymbol = currency[0].country.currency.symbol;
        this.carrierId = this.events.getCarrierIdChanges().subscribe(
          (data: any) => {
            this.getOrders();
            const rupee = JSON.parse(localStorage.getItem('carriers'));
            this.currencySymbol = rupee[0].country.currency.symbol;
          },
          (err: any) => {
            console.log('Err ::', err);
          }
        );
      }
    });
  }

  getOrders(filter: any = {}) {
    // filter.type = type;
    this.showLoader = true;
    filter.limit = this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    filter.is_deleted = this.selectedStatus.is_deleted;
    if (this.filter) {
      filter.dashboard_filter = this.filter;
    }
    let url = 'orders/normal'
    // changed from /orders to /orders/normal
    if (this.selectedOrderStatus != 'active') {
      delete filter.is_deleted;
      url = 'orders/flash'
    }
    // this.http.get('orders/normal', filter).subscribe(
    this.http.get(url, filter).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.totalCount = data.data.count
          // this.ordersArray = data.data.orders;   
          if (this.selectedOrderStatus == 'active') {
            this.ordersArray = data.data.orders;
          } else {
            this.ordersArray = data.data.orders.filter(x => x.is_deleted == false)
          }
          // this.totalOrders = data.data.count || 20;
          this.totalOrders = this.ordersArray.length || 20;
          this.orders = [];
          this.ordersArray.forEach((element, i) => {
            
            const temp: any = {};
            temp._id = element._id;
            temp.allocations = element.allocations;
            temp.accepted = element.accepted;
            temp.to_be_accepted = element.to_be_accepted;
            temp.freight = element.allocations[element.allocations.length - 1].rate;
            temp.to_be_assigned = element.to_be_assigned;
            temp.to_be_allocated = element.to_be_allocated;
            temp.created_at = element.created_at;
            temp.rejected = element.rejected;
            temp.shipper = element.shipper;
            temp.order = element.OIN;
            temp.pickDate = this.timeService.toShortDateTime(element.pickup_locations[0].date_time);
            temp.from = element.pickup_locations;
            temp.dropDate = this.timeService.toShortDateTime(element.delivery_locations[0].date_time);
            temp.to = element.delivery_locations;
            temp.vehicle = element.vehicle_type ? element.vehicle_type : 'N/A';
            temp.costPerVehicle = (element.allocations.length) ? element.allocations[element.allocations.length - 1].rate_per_km : 'N/A';
            temp.status = (element.accepted > 0) ? true : false;
            temp.cancelled_vehicles = element.cancelled_vehicles;
            temp.requested = element.req_no_of_vehicles;
            temp.delete_reason = element.delete_reason ? element.delete_reason : '--';
            temp.docs = (element.doc_urls && element.doc_urls.length) ? element.doc_urls.map(element => {
              return {
                extension: element.substr(element.lastIndexOf('.')).substr(1),
                link: element
              };
            }) : [];
            temp.accessories = element.accessories ? element.accessories : [];
            temp.permits = element.permits ? element.permits : [];
            temp.materials = element.materials ? element.materials : [];
            temp.shipmentWeight = element.per_vehicle_weight;
            temp.bidding = element.is_bidding ? 'Yes' : 'No';
            temp.comments = element.comments ? element.comments : '--';
            temp.packages = element.no_of_packages ? element.no_of_packages : '--';
            temp.purchase_order = element.purchase_orders || [];
            temp.cbm = element.cbm_value ? element.cbm_value : '--';
            // join all elements of element.project_codes into a string with comm
            temp.project_codes = element.project_codes ? element.project_codes.join(', ') : '--';
            temp.lcExpiryDate = element.lc_expiry_date ? this.timeService.toShortDateTime(element.lc_expiry_date) : '';
            temp.soNumber = element.sale_order ? element.sale_order : '--';
            temp.segmentations = element.segmentations ? element.segmentations : [];
            if (element.payment_term) {
              temp.payment_term = element.payment_term;
            }
            temp.uom = element.uom || '';
            temp.allocation_type = element.allocation_type;
            temp.rate = element.rate ? element.rate : 'N/A';
            temp.weight_based = element.weight_based;
            temp.tracker = element.trip_tracker;
            temp.sale_order = element.sale_order;
            this.orders.push(temp);
          });
          this.showLoader = false;
          if (!this.ordersList) {
            this.ordersList = new MatTableDataSource(this.orders);
            this.ordersList.sort = this.sort;
            this.ordersList.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('BIDORDER.pagination_label');
          } else {
            this.ordersList = new MatTableDataSource(this.orders);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('BIDORDER.pagination_label');
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('BIDORDER.pagination_label');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  selectStatus(status) {
    this.selectedStatus = status;
    if (status.is_deleted) {// is deleted = true add the reason field to the table
      this.ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'reason'];
    } else {
      this.ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'requested', 'price', 'accepted', 'status'];
    }
    this.paginator.pageIndex = 0;
    this.dashboardFilters.is_deleted = status.is_deleted;
    this.getOrders(this.dashboardFilters);
  }

  changeOrder(status) {
    if(status === 'ltl') {
      this.route.navigateByUrl('ltl-orders');
    }
    this.selectedOrderStatus = status;
    if (status == 'active') {// is deleted = true add the reason field to the table
      this.ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'requested', 'accepted', 'status'];

    } else {
      this.ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'requested', 'price', 'status'];
    }
    this.paginator.pageIndex = 0;
    // this.dashboardFilters.is_deleted = status.is_deleted;
    this.getOrders(this.dashboardFilters);
  }

  showOrderDetails(element) {
    this.selectedOrderData = element;
    this.selectedOrderAllLocationsData = element.from.concat(element.to);
    this.showStatusTab = 1;
    this.showOrderDetailsView = 1;
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.removeFocus();
      this.getOrders(x);
    });
    this.changeDetection.detectChanges();
  }

  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }

  openShipmentDetails(row) {
    this.http.get('shipment/one?shipmentId=' + row._id).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          const dialogRef = this.dialog.open(ShipmentDetailsComponent, {
            data: data.data,
            width: '1250px',
            maxWidth: '95vw !important'
          });

          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    if (value.length >= 3) {
      // switch (type) {
      //   case 'order':
      //     this.dashboardFilters.oin = value;
      //     break;
      //   case 'shipper':
      //     this.dashboardFilters.shipper_name = value;
      //     break;
      // }
      this.reSubscribe();
      this.searchTextChanged.next(this.dashboardFilters);
    }
  }

  // pageNavigate(event: PageEvent) {
  //   this.dashboardFilters.limit = event.pageSize;
  //   this.dashboardFilters.skip = event.pageIndex * event.pageSize;
  //   this.dashboardFilters.is_deleted = this.selectedStatus.is_deleted;
  //   this.getOrders(this.dashboardFilters);
  // }

  handlePageTop(e): void {
    const { pageSize, pageIndex } = e;
    this.bottomPaginator.pageSize = pageSize;
    this.bottomPaginator.pageIndex = pageIndex;
  }

  handlePageBottom(e): void {
    const { pageSize, pageIndex } = e;
    this.topPaginator.pageSize = pageSize;
    this.topPaginator.pageIndex = pageIndex;
    this.topPaginator.page.emit(e);
  }

  ngAfterViewInit(): void {
    merge(
      this.topPaginator.page,
      this.bottomPaginator.page
    ).pipe(
      startWith({}),
      debounceTime(300)
    ).subscribe(() => {
     
      this.getOrders(this.dashboardFilters);
    });
  }

  sortOrderData(sort: Sort) { // TODO:
    const dataToFilter = this.ordersList.filteredData.slice();

    if (!sort.active || sort.direction === '') {
      this.ordersList = new MatTableDataSource(this.orders.slice());
      this.ordersList.sort = this.sort;
      return;
    }

    const filtered = dataToFilter.sort((item1: any, item2: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'order': return this.compare(item1.order, item2.order, isAsc);
        case 'pickDate': return this.timeService.compareDate(item1.pickDate, item2.pickDate, isAsc);
        case 'from': {
          let a: string, b: string;
          (item1.from[0].loc_id.name) ? a = item1.from[0].loc_id.name : a = item1.from[0].loc_id.city;
          (item2.from[0].loc_id.name) ? b = item2.from[0].loc_id.name : b = item2.from[0].loc_id.city;
          return this.compare(a, b, isAsc);
        }
        case 'to': {
          let a: string, b: string;
          (item1.to[0].loc_id.name) ? a = item1.to[0].loc_id.name : a = item1.to[0].loc_id.city;
          (item2.to[0].loc_id.name) ? b = item2.to[0].loc_id.name : b = item2.to[0].loc_id.city;
          return this.compare(a, b, isAsc);
        }
        case 'vehicle': return this.compare(item1.vehicle, item2.vehicle, isAsc);
        case 'allocation': return this.compare(item1.allocation, item2.allocation, isAsc);
        case 'materials': return this.compare(item1.materials[0].name, item2.materials[0].name, isAsc);
        case 'organization': return this.compare(item1.organization.name, item2.organization.name, isAsc);
        case 'status': return this.compare(item1.status, item2.status, isAsc);
        default: return 0;
      }
    });
    this.ordersList = new MatTableDataSource(filtered);
    this.ordersList.sort = this.sort;
    return;
  }

  compare(item1: number | string, item2: number | string, isAsc: boolean) {
    return (item1 < item2 ? -1 : 1) * (isAsc ? 1 : -1);
  }

  openAcceptModal(data) {

    if (!data.accepted) {
      data.to_be_accepted = data.allocated - data.cancelled_before_acceptance;
    } else {
      data.to_be_accepted = data.allocated - data.cancelled_after_acceptance;
    }
    const parentdata: any = {
      allocation_id: data._id,
      allocated: data.allocated,
      cancelled: data.cancelled,
      to_be_accepted: data.to_be_accepted,
      rate: data.rate,
      rate_per_weight: data.rate_per_weight ? data.rate_per_weight : 0,
      rate_type: data.rate_type,
      order: this.selectedOrderData,
      rate_sub_type: data.rate_sub_type,
      uom: data.uom,
      allocation_type: data.allocation_type,
    };
    if (data.uom === 'Pallets') parentdata.rate_per_pallet = data.rate_per_pallet ? data.rate_per_pallet : 0;
    const dialogRef = this.dialog.open(AcceptModalComponent, {
      data: parentdata
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getOrders();
        this.openAssignSideModal(this.selectedOrderData);
      }
    });
  }

  openAssignModal(data) {
    const parentdata = {
      order_id: this.selectedOrderData._id,
      allocation_id: data._id,
      order: this.selectedOrderData,
      assign_number: (data.accepted - data.cancelled_after_acceptance - data.assigned)
    };
    const dialogRef = this.dialog.open(AssignModalComponent, {
      data: parentdata,
      width: "1250px",
      maxWidth: "95vw !important",
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getOrders();
        this.openAssignSideModal(this.selectedOrderData);
      }
    });
  }

  changeDateFormat(date) {
    return this.timeService.toShortDateMonth(date) + ' | ' + this.timeService.formatDate(date);
  }

  getShipmentStatus() {
    this.shipmentStatusArray = [];
    this.http.get('shipment/by_order?order_id=' + this.selectedOrderData._id).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data.length) {
            const allShipments: any = data.data;
            allShipments.forEach(element => {
              if (element.status == 'ASN') {
                this.assigned = element.shipments;
                this.shipmentStatusArray = this.assigned;
              } else if (element.status == 'CPTD') {
                this.completed = element.shipments;
              } else if (element.status === 'ITNS') {
                this.inTransit = element.shipments;
              }
            });
          }
        }
      },
      (err: any) => {
        console.log('ERr::', err);
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  changeTab() {
    if (this.tab == 0) {
      this.shipmentStatusArray = this.assigned;
    }
    if (this.tab == 1) {
      this.shipmentStatusArray = this.inTransit;
    }
    if (this.tab == 2) {
      this.shipmentStatusArray = this.completed;
    }
  }

  openAssignSideModal(element1) {

    this.showStatusTab = 1;
    this.showOrderDetailsView = 0;
    this.selectedOrderData = element1;
    this.http.get('order/allocations?order=' + element1._id).subscribe(
      (data: any) => {
        const allocationData = data.data;
        this.allocationDataSource = [];
        if (allocationData.length) {
          allocationData.forEach((element, index) => {
            const now: any = DateTime.local();
            const deadline: any = this.timeService.IsoToUTC(element.assignment_deadline);
            const deadlineAcc: any = this.timeService.IsoToUTC(element.acceptance_deadline);


            const temp: any = {
              allocationArray: [],
            };
            temp.created_at = this.timeService.toShortDateTime(
              element.created_at,
              "dd-MMM-yyyy, hh:mm a"
            );;
            temp.allocationArray = [{

              slno: index + 1,
              accepted: element.accepted,
              // deadline: this.timeService.toShortDateMonth(element.acceptance_deadline),
              assignmentDeadline: (element.assignment_deadline) ? this.timeService.toShortDateMonthTime(element.assignment_deadline) : '',
              acceptanceDeadline: (element.acceptance_deadline) ? this.timeService.toShortDateMonthTime(element.acceptance_deadline) : '',
              disableAssign: (element.assignment_deadline) ? ((deadline.ts > now.ts) ? true : false) : false,
              disableAccept: (element.acceptance_deadline) ? (deadlineAcc.ts > now.ts) ? true : false : false,
              disableAcceptBtn: (element.allocated != element.cancelled),
              assigned: element.assigned,
              cancelled: element.cancelled,
              cancelled_after_acceptance: element.cancelled_after_acceptance,
              cancelled_before_acceptance: element.cancelled_before_acceptance,
              to_be_assigned: element.accepted - (element.assigned + element.cancelled),
              assign_number: (element.accepted - element.cancelled_after_acceptance - element.assigned),
              rejected: element.rejected,
              rate: element.rate,
              rate_per_weight: element.rate_per_weight ? element.rate_per_weight : 0,
              rate_per_pallet: element.rate_per_pallet ? element.rate_per_pallet : 0,

              offered_price: element.rate_per_weight ? element.rate_per_weight : element.rate_per_pallet ? element.rate_per_pallet : element.rate,
              rate_type: element.rate_type,
              allocated: element.allocated,
              uom: element.order.uom,
              disable_btns: (element.accepted == 0 && element.rejected > 0) ? true : false, // if accepted = 0 and rejected > 0 show the action as rejected
              _id: element._id,
              carrier: element.carrier,
              OIN: element.order.OIN,
              allocation_type: element1.allocation_type
            }]

            this.allocationDataSource.push(temp);

            // this.allocationDataSource.push({

            //   slno: index + 1,
            //   accepted: element.accepted,
            //   // deadline: this.timeService.toShortDateMonth(element.acceptance_deadline),
            //   assignmentDeadline: (element.assignment_deadline) ? this.timeService.toShortDateMonthTime(element.assignment_deadline) : '',
            //   acceptanceDeadline: (element.acceptance_deadline) ? this.timeService.toShortDateMonthTime(element.acceptance_deadline) : '',
            //   disableAssign: (element.assignment_deadline) ? ((deadline.ts > now.ts) ? true : false) : false,
            //   disableAccept: (element.acceptance_deadline) ? (deadlineAcc.ts > now.ts) ? true : false : false,
            //   disableAcceptBtn: (element.allocated != element.cancelled),
            //   assigned: element.assigned,
            //   cancelled: element.cancelled,
            //   cancelled_after_acceptance: element.cancelled_after_acceptance,
            //   cancelled_before_acceptance: element.cancelled_before_acceptance,
            //   to_be_assigned: element.accepted - (element.assigned + element.cancelled),
            //   assign_number: (element.accepted - element.cancelled_after_acceptance - element.assigned),
            //   rejected: element.rejected,
            //   rate: element.rate,
            //   rate_per_weight: element.rate_per_weight ? element.rate_per_weight : 0,
            //   rate_per_pallet: element.rate_per_pallet ? element.rate_per_pallet : 0,

            //   offered_price: element.rate_per_weight ? element.rate_per_weight : element.rate_per_pallet ? element.rate_per_pallet : element.rate,
            //   rate_type: element.rate_type,
            //   allocated: element.allocated,
            //   uom: element.order.uom,
            //   disable_btns: (element.accepted == 0 && element.rejected > 0) ? true : false, // if accepted = 0 and rejected > 0 show the action as rejected
            //   _id: element._id,
            //   carrier: element.carrier,
            //   OIN: element.order.OIN,
            // });


          });
          if (this.allocTable) {
            this.allocTable.renderRows();
          }
        }
      }
    );

  }
  openOrderDetails(element) {
    const dialogRef = this.dialog.open(OrderDetailsComponent, {
      data: element
    });
  }
  openUploadDocs() {

    this.uploadDocsRef = this.dialog.open(this.uploadDocs, {

    });
  }
  parellAccept(element) {

    let data = {
      // carrier: "string",
      // accepted_veh: 0,
      order_id: element._id
    }

    this.http.post('order/parallelAllocationAccept', data).subscribe(
      (data: any) => {

        if (data.statusCode === 200) {
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.PARALLEL.SUCCESS.ALLOCATION'), '');
          this.getOrders();
        }

      },
      (err: any) => {

        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  openChatBox(item) {
    console.log('item', item);
    if (item._id) {
      this.documentId = (item._id);
      this.orderNumber = (item.OIN);
    }
    this.chatboxRef = this.dialog.open(this.ChatBoxComponent, {
      panelClass: "chat-box-dialog",
    });
    this.getAllMessages();
  }
  ngAfterViewChecked() {
    try {
      this.outerbody.nativeElement.scrollTop = this.outerbody.nativeElement.scrollHeight;
    } catch (err) { }
  }
  sendMessage() {
    const payload = {
      type: 'Carrier',
      message: this.textMessage,
      documentId: this.documentId,
      orderNumber: this.orderNumber,
    };

    this.http.post('v1/order/send_message', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.textMessage = '';
          this.getAllMessages();
          this.snackbar.openSnackBar(this.translation.instant('ORDER_DASHBOARD.messageSent'), '');
        }
      });
  }

  getAllMessages() {
    const payload = {
      documentId: this.documentId,
    };
    this.http.get('v1/order/view_message', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.messageArray = [];
          const shipper_carrier_message = data.data;
          if (shipper_carrier_message && shipper_carrier_message.length) {
            shipper_carrier_message.forEach(element => {
              const temp: any = {}
              temp.typeOfUser = element.type;
              temp.message = element.message;
              temp.sentDate = this.timeService.toShortDate(element.sentDate);
              temp.sentTime = this.timeService.toShortDate(element.sentDate, 'hh:mm a');
              temp.typeId = element.typeId;
              this.messageArray.push(temp);
            });
          }
        }
      });
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
